import { getPageViewData } from './platform';
import { sendEventV2Once } from '@/utils/analytics';

export function sendPageViewEvent() {
    try {
        const { strings, numbers } = getPageViewData();
        sendEventV2Once('pageview', strings, numbers);
    } catch (err) {
        console.warn('Failed to send pageview event', err);
    }
}

function isSoftwareRenderer(renderer: string): boolean {
    const softwareRenderers = [
        'swiftshader', // Chrome/Chromium software rasterizer
        'llvmpipe', // Mesa CPU rasterizer (Linux)
        'softpipe', // Mesa Gallium software rasterizer
        'lavapipe', // Mesa Vulkan software rasterizer
        'microsoft basic render', // Windows fallback adapter
        'direct3d11 warp', // Windows WARP software path
        'warp', // shorthand catch for WARP
        'gdi generic', // Old Windows OpenGL fallback
        'software rasterizer', // Explicit "Software Rasterizer"
        'software renderer', // Explicit "Software Renderer"
        'software adapter', // Seen in some ANGLE WARP paths
        'apple software renderer', // macOS fallback (rare)
    ];
    return softwareRenderers.some((sw) => renderer.toLowerCase().includes(sw));
}

export function sendGraphicsCapabilityEvent() {
    if (process.env.PUBLIC_TRACK_GRAPHICS_CAPABILITY !== 'true') return;
    try {
        const canvas = document.createElement('canvas');
        const gl =
            (canvas.getContext('webgl') as WebGLRenderingContext | null) ||
            (canvas.getContext('experimental-webgl') as WebGLRenderingContext | null);

        let renderer: string = 'unknown';
        let type: 'hardware' | 'software' = 'software';

        if (gl) {
            const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
            if (debugInfo) {
                const r = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
                if (typeof r === 'string') {
                    renderer = r;
                    type = isSoftwareRenderer(renderer) ? 'software' : 'hardware';
                }
            } else {
                console.log('[Arise] Graphics capability: No debug renderer info, defaulting to hardware');
                type = 'hardware';
            }
        }

        console.log('[Arise] Graphics capability:', [renderer, type]);
        sendEventV2Once('graphics_capability', [renderer, type]);
    } catch (err) {
        console.log('[Arise] Graphics capability failed to send', err);
    }
}
